module.exports = __webpack_public_path__ + "static/media/modal-backing-9-slice-web.c88c8bc7.png";